var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCuponDicount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h24v24h-24v-24Z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.89,12.11l0.55,-0.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.57,15.43l-0.55,0.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.013,14.071c-0.091,0.377 -0.009,0.783 0.286,1.078l0.276,0.276l0.329,0.329c0.428,0.428 1.122,0.428 1.55,0c0.355,-0.355 0.424,-0.907 0.165,-1.338l-0.775,-1.294c-0.258,-0.431 -0.19,-0.983 0.165,-1.338c0.428,-0.428 1.122,-0.428 1.55,0l0.329,0.329l0.276,0.276c0.294,0.294 0.376,0.699 0.287,1.075"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.8073,8.19266c0.144885,0.144885 0.144885,0.379789 0,0.524673c-0.144885,0.144885 -0.379789,0.144885 -0.524673,0c-0.144885,-0.144885 -0.144885,-0.379789 0,-0.524673c0.144885,-0.144885 0.379789,-0.144885 0.524673,0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.512,4h4.385c1.162,0 2.103,0.941 2.103,2.102v4.385c0,0.558 -0.222,1.092 -0.616,1.487l-8.41,8.41c-0.821,0.821 -2.152,0.821 -2.973,0l-4.385,-4.385c-0.821,-0.821 -0.821,-2.152 0,-2.973l8.41,-8.41c0.394,-0.394 0.929,-0.616 1.486,-0.616Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuponDicount);
export default __webpack_public_path__ + "static/media/CuponDicount.3865b777a38f5ee3fb7435496d6ce5c8.svg";
export { ForwardRef as ReactComponent };